import React, { useContext } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";

import AppSettingsContext from "../../../context/AppSettingsContext";
import WaitlistButton from "./WaitlistButton";

import { Button, Icon } from "tabler-react";

function ShopClassesScheduleButtonBook({
    t,
    match,
    history,
    scheduleItemId,
    classDate,
    bookingOpenOn,
    bookingStatus,
    scheduleClass,
    waitlistEnabled,
}) {
    const appSettings = useContext(AppSettingsContext);
    const dateFormat = appSettings.dateFormat;

    const {
        isBookable,
        userBookingStatus,
        waitlistEnabled: classWaitlistEnabled,
        canJoinWaitlist,
    } = scheduleClass || {};

    let buttonBook;
    // Uncomment the line below when testing the book component statuses. (Development only)
    // bookingStatus = "OK"

    // Check if user already has a booking for this class
    if (userBookingStatus) {
        switch (userBookingStatus) {
            case "BOOKED":
            case "ATTENDING":
                buttonBook = (
                    <span className="pull-right text-success">
                        <Icon name="check" className="mr-1" />
                        {t("shop.classes.user_status.booked")}
                    </span>
                );
                return buttonBook;
            case "WAITLISTED":
                buttonBook = (
                    <div className="pull-right">
                        <WaitlistButton
                            scheduleClass={scheduleClass}
                            classDate={classDate}
                            scheduleItemId={scheduleItemId}
                            bookingStatus={bookingStatus}
                        />
                    </div>
                );
                return buttonBook;
            case "CANCELLED":
            case "CANCELLED_WAITLIST":
                // User had cancelled - allow rebooking if possible
                break;
            default:
                break;
        }
    }

    switch (bookingStatus) {
        case "NOT_YET_OPEN":
            buttonBook = (
                <span className="pull-right">
                    {t("shop.classes.class_booking_status.open_on") +
                        " " +
                        moment(bookingOpenOn).format(dateFormat)}
                </span>
            );
            break;
        case "CANCELLED":
            buttonBook = (
                <span className="pull-right">
                    {t("shop.classes.class_booking_status.cancelled")}
                </span>
            );
            break;
        case "HOLIDAY":
            buttonBook = (
                <span className="pull-right">
                    {t("shop.classes.class_booking_status.cancelled_holiday")}
                </span>
            );
            break;
        case "FINISHED":
            buttonBook = (
                <span className="pull-right">
                    {t("shop.classes.class_booking_status.finished")}
                </span>
            );
            break;
        case "ONGOING":
            buttonBook = (
                <span className="pull-right">
                    {t("shop.classes.class_booking_status.ongoing")}
                </span>
            );
            break;
        case "FULL":
            if (waitlistEnabled && classWaitlistEnabled && canJoinWaitlist) {
                buttonBook = (
                    <div className="pull-right">
                        <WaitlistButton
                            scheduleClass={scheduleClass}
                            classDate={classDate}
                            scheduleItemId={scheduleItemId}
                            bookingStatus={bookingStatus}
                        />
                    </div>
                );
            } else {
                buttonBook = (
                    <span className="pull-right">
                        {t("shop.classes.class_booking_status.full")}
                    </span>
                );
            }
            break;
        case "OK":
            if (isBookable) {
                buttonBook = (
                    <Link
                        to={`/shop/classes/book/${scheduleItemId}/${classDate}`}
                    >
                        <Button className="pull-right" color="primary" outline>
                            {t("general.book")} <Icon name="chevron-right" />
                        </Button>
                    </Link>
                );
            } else {
                buttonBook = "";
            }
            break;

        default:
            buttonBook = "";
    }

    return buttonBook;
}

export default withTranslation()(withRouter(ShopClassesScheduleButtonBook));
